export { default as MaterialsIndexPageBreadcrumbs } from './MaterialsIndexPageBreadcrumbs';
